"use client"

import { useEffect, useState } from "react"
import "./Gallery.css"

const Gallery = ({ language }) => {
  const [isVisible, setIsVisible] = useState(false)
  const [selectedImage, setSelectedImage] = useState(null)

  useEffect(() => {
    setIsVisible(true)
  }, [])

  const publicImages = [
    "AKTH.jpg", "AWARD3.jpeg", "BICHIFC.jpg", "BICHIFC1.jpg", "Homepic.jpeg", "images (31).jpeg", "images (33).jpeg", "images (34).jpeg", "images (35).jpeg", "images (36).jpeg", "images (37).jpeg", "images (39).jpeg", "images (40).jpeg", "images (43).jpeg", "IMG-20241103-WA0011-735x400.jpg", "img_10_1758916118622.jpg", "img_10_1759050573334.jpg", "img_11_1758916176149.jpg", "img_11_1759050583878.jpg", "img_12_1758916185877.jpg", "img_13_1758916201469.jpg", "img_14_1758916234930.jpg", "img_15_1758916360000.jpg", "img_16_1758916367005.jpg", "img_17_1758916376100.jpg", "img_1_1758915997345.jpg", "img_1_1759050102006.jpg", "img_1_1759050401104.jpg", "img_21_1758916555601.jpg", "img_2_1759050107392.jpg", "img_2_1759050421254.jpg", "img_3_1758916011349.jpg", "img_3_1759050119353.jpg", "img_3_1759050429215.jpg", "img_4_1758916016802.jpg", "img_4_1759050125156.jpg", "img_4_1759050439162.jpg", "img_5_1758916027468.jpg", "img_5_1759050131850.jpg", "img_5_1759050447360.jpg", "img_6_1758916036795.jpg", "img_6_1759050132013.jpg", "img_6_1759050510338.jpg", "img_7_1759050142284.jpg", "img_7_1759050521642.jpg", "img_8_1759050149914.jpg", "img_8_1759050538209.jpg", "img_9_1758916095168.jpg", "img_9_1759050274983.jpg", "img_9_1759050562053.jpg", "MODERNCITY.jpg", "MODERNCITY2.jpg", "MODERNCITY3.jpg"
  ];

  const translations = {
    en: {
      heroTitle: "Projects Snapshot",
      heroDescription:
        "Visual documentation of some of the development projects, community engagements, and transformative initiatives across Bichi Federal Constituency and Nigeria as a whole by done by Hon. Abubakar Kabir Abubakar\nMember Representing Bichi Federal Constituency & Chairman House of Representatives Committee on Appropriations.",
      overviewTitle: "Projects Snapshot",
      overviewDescription:
        "A selection of images showing development projects, community engagement, and transformation led by Hon. Abubakar Kabir Abubakar.",
      featuredCaption: "Bichi Modern City Project - Construction site visit and project inspection",
      galleryItems: publicImages.map((img, idx) => ({
        id: idx + 1,
        title: `Project Image ${idx + 1}`,
        description: "Development and engagement snapshot.",
        image: `/${img}`
      })),
    },
    ha: {
      heroTitle: "Hotunan Ayyuka",
      heroDescription: "Hotunan da ke nuna ayyukan ci gaba, hulɗar al'umma, da shirye-shiryen canza a Mazabar Bichi da Najeriya baki daya, wanda Hon. Abubakar Kabir Abubakar ya jagoranta.",
      overviewTitle: "Hotunan Ayyuka",
      overviewDescription:
        "Zaɓaɓɓun hotuna da ke nuna ayyukan ci gaba, hulɗar al'umma, da sauyi da Hon. Abubakar Kabir Abubakar ya jagoranta.",
      featuredCaption: "Aikin Birnin Bichi na Zamani - Ziyarar wurin gini da duba aikin",
      galleryItems: publicImages.map((img, idx) => ({
        id: idx + 1,
        title: `Hoton Aiki ${idx + 1}`,
        description: "Hoton ci gaba da hulɗa da al'umma.",
        image: `/${img}`
      })),
    },
  }

  const t = translations[language]

  const openModal = (item) => {
    setSelectedImage(item)
  }

  const closeModal = () => {
    setSelectedImage(null)
  }

  return (
    <div className="gallery">
      {/* Hero Section */}
      <section className="gallery-hero">
        <div className={`gallery-hero-content ${isVisible ? "fade-in" : ""}`}>
          <h1>{t.heroTitle}</h1>
          <p>{t.heroDescription}</p>
        </div>
      </section>

      {/* Gallery Content */}
      <div className="gallery-content">
        <section className={`gallery-overview ${isVisible ? "slide-in-up" : ""}`}>
          <h2>{t.overviewTitle}</h2>
          <p>{t.overviewDescription}</p>
        </section>

        {/* Animated Gallery Grid */}
        <div className={`gallery-grid animated-gallery ${isVisible ? "slide-in-up" : ""}`}
          style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem' }}>
          {t.galleryItems.map((item, index) => (
            <div key={item.id} className="gallery-item" style={{ animation: `moveGallery 30s linear infinite` }} onClick={() => openModal(item)}>
              <img src={item.image} alt={item.title} className="gallery-image" style={{ width: '100%', height: '250px', objectFit: 'cover', borderRadius: '15px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }} />
              <div className="gallery-overlay">
                <h3 className="gallery-title">{item.title}</h3>
                <p className="gallery-description">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Modal */}
      {selectedImage && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>
              ×
            </button>
            <img src={selectedImage.image || "/placeholder.svg"} alt={selectedImage.title} className="modal-image" />
            <div className="modal-info">
              <h3 className="modal-title">{selectedImage.title}</h3>
              <p className="modal-description">{selectedImage.description}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Gallery
